export const integrationListSelector = (state: any) => {
  return state.SettingReducer.integrationList;
};
